import * as React from "react"
import type { SVGProps } from "react"
const SvgCodeFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m9 16.07 1.4-1.4a1 1 0 0 0 .27-.65 1 1 0 0 0-.28-.66 1 1 0 0 0-.67-.29 1 1 0 0 0-.68.28L7 15.42a1 1 0 0 0-.2.3q-.06.17-.06.36 0 .2.06.36t.2.3l2.06 2.06a1 1 0 0 0 .67.28 1 1 0 0 0 .67-.28 1 1 0 0 0 .28-.66 1 1 0 0 0-.28-.66zm6 0-1.4 1.4a1 1 0 0 0-.28.66q0 .38.28.66a1 1 0 0 0 .68.28 1 1 0 0 0 .67-.28l2.06-2.06a1 1 0 0 0 .2-.3 1 1 0 0 0 0-.71 1 1 0 0 0-.2-.31l-2.06-2.06a.94.94 0 0 0-1.35 0 1 1 0 0 0-.28.67q0 .38.28.66z" />
    <path
      fillRule="evenodd"
      d="M4.59 21.98q.59.6 1.41.6h12q.83 0 1.41-.6.6-.59.59-1.4V9.4a2 2 0 0 0-.57-1.4l-4.85-4.85a2 2 0 0 0-1.4-.58H6q-.82 0-1.41.59A2 2 0 0 0 4 4.57v16q0 .82.59 1.41M13 4.57v4q0 .42.29.71.29.3.71.29h4v11H6v-16z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgCodeFile
